













import { defineComponent }            from '@vue/composition-api';
import ElBreadcrumb                   from 'element-ui/lib/breadcrumb';
import ElBreadcrumbItem               from 'element-ui/lib/breadcrumb-item';
import { GlobalContexts, useGlobals } from '@/hooks/use-globals';
import { Breadcrumb }                 from '@/types';

export default defineComponent({
  name: 'breadcrumb.component',
  components: {
    ElBreadcrumb,
    ElBreadcrumbItem,
  },
  props: {
    translations: {
      required: true,
    },
  },
  setup() {
    const { router }: GlobalContexts = useGlobals();

    const breadcrumbPath = (): Breadcrumb[] => {
      const breadcrumbs: Breadcrumb[] = router.currentRoute.meta.breadcrumb;
      return breadcrumbs.map((breadcrumb: Breadcrumb) => {
        if (breadcrumb.path.includes(':')) {
          const splitUrl: string[] = breadcrumb.path.split('/');
          const params: string[] = splitUrl.filter((chunk: string) => chunk.charAt(0) === ':');
          let newBreadcrumbPath: string = breadcrumb.path;
          params.forEach((param: string) => {
            const paramName: string = param.substring(1);
            const regexp = new RegExp(param, 'g');
            newBreadcrumbPath = newBreadcrumbPath.replace(regexp, router.currentRoute.params[ paramName ]);
          });
          return { ...breadcrumb, path: newBreadcrumbPath };
        }
        return breadcrumb;
      });
    };

    return {
      breadcrumbPath,
    };
  },
});
